<template>
  <header id="header">
    <v-container fluid class="header-container">
      <v-row>
        <v-col class="v-col-logo" v-if="advertiser">
          <LogoInfo :company="advertiser.company"/>
        </v-col>
        <v-col justify="center" v-if="advertiser">
          <v-container class="header-container-right" fluid>
            <v-row justify="center" align="center" fluid>
              <Carrousel :moreViews="advertiser.more_views"/>
              <ProfileModal />
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </header>

</template>

<script>
import {mapState} from "vuex";
import Carrousel from "./components/Carrousel.vue";
import LogoInfo from "./components/LogoInfo.vue";
import ProfileModal from "@/components/SimpleHeader/components/ProfileModal.vue";

export default {
  components: {
    ProfileModal,
    Carrousel,
    LogoInfo
  },
  name: "AdvertiserHeaderDesktop",
  data() {
    return {
      fantasia: '',
      isScrolled: false,
    };
  },
  computed: {
    ...mapState('advertiser', {
      advertiser: state => state.list,
    })
  },
  methods: {
    handleScroll(e) {
      const scrollTop = e.target.scrollTop;
      const header = document.getElementById('header');
      if (!header) return;

      if (scrollTop > 5) {
        header.classList.add('header--retraido');
      } else {
        header.classList.remove('header--retraido');
      }
    },
  },
  beforeUnmount() {
    const container = document.getElementById('filter-result-app');
    if (container) {
      container.removeEventListener('scroll', this.handleScroll);
    }
  },
  mounted() {
    this.fantasia = this.$route.params.name
    this.$store.dispatch('advertiser/getAdvertiser', this.fantasia);

    this.$nextTick(() => {
    const container = document.getElementById('filter-result-app');
    if (container) {
      container.addEventListener('scroll', this.handleScroll);
    }
    });
  },
};
</script>

<style lang="scss" scoped>
header {
  padding-bottom: 6px;
  background: linear-gradient(to right, #333, #000);
  position: relative; /* Alterado de fixed para relative */
  width: 100%;
  z-index: 1;
  transition: all 0.3s ease;

  &.header--retraido {
    transform: translateY(-200%);
    display: none;
  }

  .v-col-logo {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: end;
  }
}
</style>
